import React from 'react';

const AvatarGroup: React.FC<any> = props => <div className='avatar-group nowrap'>{props.children}</div>;

export default AvatarGroup;
